// this file is auto generated by ng g @mooxy/schematics:data-access if you want to edit
// actions the recommended way is using the following command:
// ng g @mooxy/schematics:action

import {createActionWithCorrelation} from "@kion/ngrx-helper";
import {props} from "@ngrx/store";
import {ContractPartner} from "@kion/data-models";

export const loadAllSuccess = createActionWithCorrelation(
  "[ContractPartner] loadAll Success",
  props<{ contractPartners: ContractPartner[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[ContractPartner] loadAll Error",
  props<{ error: any }>()
);
export const loadAll = createActionWithCorrelation(
  "[ContractPartner] loadAll",
  loadAllSuccess.type,
  loadAllError.type
);

export const setContractPartnerSuccess = createActionWithCorrelation(
  "[ContractPartner] setContractPartner Success"
);
export const setContractPartnerError = createActionWithCorrelation(
  "[ContractPartner] setContractPartner Error",
  props<{ error: any }>()
);
export const setContractPartner = createActionWithCorrelation(
  "[ContractPartner] setContractPartner",
  props<{ networkPartnerId: string, cartId: string }>(),
  setContractPartnerSuccess.type,
  setContractPartnerError.type
);
